module.exports = __webpack_public_path__ + "static/media/xmg_drops_product.dd8c2729.png";